import React, { PropTypes, PureComponent } from 'react';
import Helmet from 'react-helmet';
import { setPageInfo } from 'common/page/actions';
import injectIntl, { intlShape } from 'common/injectIntl';
import openFeedbackPage from 'lib/ui/openFeedbackPage';
import appConfig from 'config';

const {
    shellVersion,
    secureCdnHost,
    devStyles
} = appConfig;

let STYLE_HREF = `${secureCdnHost}/redesign/${shellVersion}/css`;
if (devStyles) {
    STYLE_HREF = 'http://localhost:8080/static/css';
}

const classes = {
    container: 'watch__roadblock',
    logo: 'watch__roadblock-logo',
    pageTitle: 'watch__roadblock_page-title',
    roadblockText: 'watch__roadblock-text',
    main: 'watch__roadblock-main',
    fullSite: 'watch__roadblock-full-site',
    footer: 'watch__roadblock-footer',
    footerA: 'watch__roadblock-footer-a'
};

class UnsupportedPage extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {
            messages,
            intl: { formatMessage }
        } = this.props;

        const logo = <img alt="ESPN" width="200" src={`${secureCdnHost}/watchespn/images/roadblock/espn@2x.png`} />;

        return (
            <div className={classes.container}>
                <Helmet
                    meta={[{
                        name: 'viewport',
                        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
                    }]}
                    link={[
                        { rel: 'stylesheet', href: `${STYLE_HREF}/page-shell.css` },
                        { rel: 'stylesheet', href: `${STYLE_HREF}/watch-provider.css` }
                    ]}
                    style={[{
                        cssText: `
                            body {
                                margin: 0;
                                background: #fff !important;
                                font: normal 12px/18px BentonSans, helvetica, arial, sans-serif;
                                min-width: 100%;
                            }
                            .${classes.logo} {
                                text-align: center;
                            }
                            .${classes.logo} img { margin: 20px auto; }
                            .${classes.pageTitle} {
                                margin-bottom: 20px;
                            }
                            .${classes.roadblockText} {
                                display: block;
                                color: #262626 !important;
                                font-size: 16px;
                            }
                            .${classes.container} {
                                width: 295px !important;
                                background: #fff !important;
                                margin: 0 auto;
                                border-radius: 12px;
                                text-align: center;
                                -moz-border-radius: 0 !important;
                                -webkit-border-radius: 0 !important;
                                box-shadow: none !important;
                                -webkit-box-shadow: none !important;
                            }
                            .${classes.main} a {
                                cursor: pointer;
                            }
                            .${classes.main} a:hover {text-decoration: underline;}

                            .${classes.main} p {
                                text-align: center;
                                margin: 10px 0 25px 0;
                            }
                            .${classes.main} .${classes.fullSite} {
                                color: #2d66eb;
                                font-size: 14px;
                                font-family: BentonSans, helvetica, arial, sans-serif;
                                text-decoration: none;
                            }
                            .${classes.footer} {
                                display: flex;
                                justify-content: space-between;
                            }
                            .${classes.footer} a {
                                color: #0066CC !important;
                                flex-grow: 1;
                                padding: 4px 0;
                            }
                            .${classes.footer} a:first-child{
                                font-weight: 600;
                            }
                            .${classes.footer} a + a{
                                border-left: 1px #dcdddf solid;
                            }
                            .strong{
                                font-weight: 600;
                            }
                        `
                    }]}
                />
                <div className={classes.logo}>
                    {logo}
                </div>

                <header className={`strong ${classes.roadblockText} ${classes.pageTitle}`}>
                    {formatMessage(messages['unsupported.error.message'])}
                </header>

                <div className={classes.footer}>
                    <a href="http://www.espn.com">ESPN.com</a>
                    <a className={classes.footerA} href="/watch/schedule">Schedule</a>
                    <a className={classes.footerA} href="//support.espn.com/en_US/WatchESPN" rel="nofollow">FAQs</a>
                    <a className={classes.footerA} onClick={openFeedbackPage}>Customer Care</a>
                </div>
            </div>
        );
    }
}

UnsupportedPage.propTypes = {
    intl: intlShape.isRequired,
    messages: PropTypes.object.isRequired
};

UnsupportedPage.loadActions = [
    () => setPageInfo('unsupported', 'Unsupported')
];

export default injectIntl(UnsupportedPage);



// WEBPACK FOOTER //
// ./app/webapp/page/UnsupportedPage.js